<template>
    <section class="developments" id="key_developments">
        <div class="wrapper">
            <div class="developments__intro">
                <h2>Our Next Key Developments</h2>
                <div class="developments__text">
                    <div class="developments__text__inner">
                        <p>
                            The Board of Directors has examined all aspects of
                            our school to determine the most urgent and most
                            important developments. We have identified three:
                        </p>
                        <ul>
                            <li>
                                The first, a new library, which is now complete.
                            </li>
                            <li>
                                The second, a major new multi-purpose building
                                for Arts and Sciences.
                            </li>
                            <li>
                                The third, a significant upgrade and expansion
                                of our sports facilities.
                            </li>
                        </ul>
                    </div>
                    <ButtonLink
                        icon="brochure"
                        title="Download Brochure"
                        :link="brochureURL"
                    ></ButtonLink>
                </div>
            </div>
            <div class="developments__development">
                <div class="development__image">
                    <img
                        src="../assets/berkeley-building.jpg"
                        alt="berkley-building"
                    />
                </div>
                <div class="development__content">
                    <h3>The Berkeley Building</h3>
                    <div class="development__text">
                        <h4>A major new multi-purpose building.</h4>
                        <p>
                            Having examined current and future needs the Board
                            of Directors concluded that one multi-purpose
                            building will satisfy many needs, especially the
                            need for space to better inspire and nurture the
                            musical and artistic talents of our students.
                        </p>
                        <h5>
                            The Berkeley Building will increase our capacity to:
                        </h5>
                        <ul>
                            <li>
                                Inspire and nurture musical and artistic
                                talents.
                            </li>
                            <li>
                                Provide good quality rehearsal and performance
                                facilities.
                            </li>
                            <li>
                                Provide practical subject teaching facilities.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="developments__development">
                <div class="development__image">
                    <img src="../assets/sports.jpg" alt="hockey" />
                </div>
                <div class="development__content">
                    <h3>Sports and Recreation</h3>
                    <div class="development__text">
                        <h4>Upgrading and improving our Sports Facilities.</h4>
                        <p>
                            Pupils attending Kilkenny College are encouraged to
                            participate in an exercise programme be it at Senior
                            Inter-Schools Level or on a social level. The
                            primary goal for our teachers and coaches is to
                            provide a programme which encourages pupils to
                            engage in regular exercise.
                        </p>
                        <h5>
                            To encourage our pupils in Sports and Recreation the
                            Board of Directors have identified the need for:
                        </h5>
                        <ul>
                            <li>New Changing Facilities for Girls</li>
                            <li>Upgrading and Expanding Our Pitches</li>
                            <li>Hockey and Multi-Purpose Pitch Replacement</li>
                            <li>Rugby Pitch Replacement</li>
                            <li>Two Multi-Purpose Playing Surfaces</li>
                        </ul>
                        <h5>
                            The improved and expanded sports facilities will
                            enable:
                        </h5>
                        <ul>
                            <li>
                                The structuring of Physical Education classes in
                                a manner which will encourage students to be
                                active.
                            </li>
                            <li>
                                Coaches to plan and deliver their respective
                                programmes securely in a new all-weather
                                facility.
                            </li>
                            <li>
                                Our students to get greater enjoyment from
                                playing and participating in sport.
                            </li>
                            <li>
                                The school to enhance an income stream during
                                school closures.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.developments {
    background-color: #efefef;
    padding-bottom: 4rem;

    @include mobile {
        padding-bottom: 0;
    }

    &__text {
        display: flex;
        justify-content: space-between;

        @include tablet-and-mobile {
            display: block;
            margin-bottom: 4rem;
        }

        &__inner {
            flex-basis: 70%;
        }

        ul {
            list-style: none;
            @include checkList(var(--primary_colour));
            margin-bottom: 4rem;
        }

        p {
            margin-bottom: 2rem;
        }
    }
}

h2 {
    color: var(--primary_colour);
    font-size: 3.375rem;

    @include mobile {
        font-size: 2.8rem;
    }
}

p {
    flex-basis: 66%;
    margin-bottom: 4rem;
    margin-top: 0;
}

.button_link {
    width: 19rem;
    height: 4.688rem;
    padding: 0;
    font-size: 1.125rem !important;

    .icon {
        font-size: 1.75rem !important;
    }
}

.development {
    &__image {
        width: 100%;
        height: auto;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &__content {
        margin-top: -24rem;
        position: relative;
        right: 0;
        margin-right: 0;
        margin-left: auto;
        width: var(--wrapper-width);
        max-width: 90%;

        @include tablet {
            margin-top: -16rem;
        }

        @include mobile {
            margin-top: -7rem;
            max-width: 100%;
        }

        p {
            margin-bottom: 2.56rem;
        }

        h3 {
            font-size: 3.375rem;
            @include titleText();
            color: white;

            @include mobile {
                font-size: 2.8rem;
                max-width: 90%;
                margin: 0 auto 1rem;
                line-height: 1;
            }
        }

        h4 {
            font-size: 1.875rem;
            @include titleText();
        }

        h5 {
            font-size: 1.25rem;
            @include titleText();
            margin-top: 0;
            line-height: 1.3;
        }

        ul {
            margin-bottom: 2rem;
            @include gridBlock();
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 0 4rem;
            list-style: none;
            @include checkList(var(--primary_colour));

            @include iego {
                display: block;
            }

            @include tablet-and-mobile {
                display: block;
            }
        }
    }

    &__text {
        background: white;
        padding: 4rem;
        margin-bottom: 8rem;

        @include mobile {
            padding: 2rem 5%;
            margin-bottom: 4rem;
        }
    }
}
</style>
